const INITIAL_STATE = {
    data: null
}

const AlertReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'alert': {

            return {
                ...state,
                data: action.payload.alert
            }
        }
        default: {
            return state
        }
    }
}

export default AlertReducer